import { toDataURL } from 'qrcode';

/** Pixel width/height for print-ready admin QR exports (square image). */
export const QR_HIGH_RES_PX = 2048;

const PNG_OPTS = {
  width: QR_HIGH_RES_PX,
  margin: 2,
  errorCorrectionLevel: 'H',
  color: { dark: '#000000ff', light: '#ffffffff' },
};

/**
 * @param {string} value - Encoded QR payload (usually a full URL)
 * @returns {Promise<string>} data URL (image/png)
 */
export function getQrPngDataUrlHighRes(value) {
  if (!value || typeof value !== 'string') {
    return Promise.reject(new Error('Invalid QR value'));
  }
  return toDataURL(value, PNG_OPTS);
}

/**
 * Triggers a browser download of a high-resolution PNG.
 * @param {string} value - URL or text to encode
 * @param {string} filenameBase - without extension; sanitized for filesystem
 */
export async function downloadQrPngHighRes(value, filenameBase = 'qr-code') {
  const dataUrl = await getQrPngDataUrlHighRes(value);
  const safe = String(filenameBase || 'qr-code').replace(/[^a-z0-9-_]+/gi, '_').slice(0, 120);
  const link = document.createElement('a');
  link.download = `${safe}.png`;
  link.href = dataUrl;
  link.click();
}
